import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { EDIT_ON_CLOSED_ROLES } from '../../../utils/formValidation/commonConstants';
import {
    ADVISER,
    hasRole,
    MANAGER,
    QUALITY,
    RECRUITMENT_MANAGER,
    SUPERUSER
} from '../../../utils/userRoles';
import Button from '../../formElements/Button';

import AdditionalContactCard from './AddtionalContactCard';
import EditAdditionalContact from './EditAdditionalContact';

import app from '../../../app.module.css';
import cards from '../../../commonStyles/cardContainer.module.css';
import local from './additionalContacts.module.css';

const acceptedRoles = [ADVISER, MANAGER, QUALITY, RECRUITMENT_MANAGER, SUPERUSER];

const AdditionalContacts = ({
    currentParticipant,
    additionalContacts,
    updateAdditionalContacts
}) => {
    // LOCAL STATE
    const [currentContact, setCurrentContact] = useState({});
    const [editType, setEditType] = useState('create');
    const [isOpenEditor, setIsOpenEditor] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);

    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);

    // USE EFFECTS
    useEffect(() => {
        if (!currentParticipant?.id) return;
        const isDisabledOnClosedStatus =
            currentParticipant.status === 'Closed' && !hasRole(EDIT_ON_CLOSED_ROLES, roles);
        setIsDisabled(!hasRole(acceptedRoles, roles) || isDisabledOnClosedStatus);
    }, [currentParticipant.id]);

    // EVENTHANDLERS
    const onAddContact = () => {
        setEditType('create');
        setIsOpenEditor(true);
    };

    const onEditContact = (contact) => {
        setCurrentContact(contact);
        setEditType('edit');
        setIsOpenEditor(true);
    };

    const addContact = (newContact) => {
        const updatedContacts = [...additionalContacts, newContact];
        updateAdditionalContacts(updatedContacts);
        setIsOpenEditor(false);
    };

    const deleteContact = (contact) => {
        const filteredContacts = additionalContacts.filter((el) => el.id !== contact.id);
        updateAdditionalContacts(filteredContacts);
    };

    const updateContact = (updatedContact) => {
        setCurrentContact({});
        const newContacts = additionalContacts.map((el) =>
            el.id === updatedContact.id ? updatedContact : el
        );
        updateAdditionalContacts(newContacts);
        setIsOpenEditor(false);
    };

    // RENDER
    return (
        <div className={cards.cardContainer}>
            <h2 className={app.sectionHeading}>Additional Contacts</h2>

            <div className={cards.cards}>
                {additionalContacts?.map((el) => (
                    <div key={el.id}>
                        <AdditionalContactCard
                            contact={el}
                            isDisabled={isDisabled}
                            onEditContact={onEditContact}
                            onDeleteContact={deleteContact}
                        />
                    </div>
                ))}
                {isOpenEditor && (
                    <EditAdditionalContact
                        contact={currentContact}
                        participantId={currentParticipant.id}
                        isDisabled={isDisabled}
                        editType={editType}
                        isOpen={isOpenEditor}
                        onCancel={() => setIsOpenEditor(false)}
                        onUpdateContact={updateContact}
                        onAddContact={addContact}
                    />
                )}
            </div>
            <div className={local.addButton}>
                <Button
                    id="AddContactCard"
                    type="button"
                    onClick={onAddContact}
                    disabled={isDisabled}
                    content="Add an Additional Contact"
                />
            </div>
        </div>
    );
};

AdditionalContacts.propTypes = {
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    currentParticipant: PropTypes.object,
    additionalContacts: PropTypes.arrayOf(PropTypes.object),
    updateAdditionalContacts: PropTypes.func
};

export default AdditionalContacts;
